<template>
  <div class="flex mb-25px">
    <YorkbbsImage aspect class="w-135px lg:w-200px" :src="cover" target="_blank" :href="url"></YorkbbsImage>
    <div class="flex-1 w-0 pl-20px flex flex-col justify-between">
      <div>
        <a class="block text-base lg:text-xl mb-20px hover:text-tax-6" target="_blank" :href="url">{{ title }}</a>
        <div class="text-base hidden lg:line-clamp-2">{{ contentText }}</div>
      </div>
      <div class="flex flex-wrap">
        <div
          class="text-sm text-gray-400 leading-none pr-1 border-r border-gray-400 mr-1 last:border-r-0"
          v-for="(item, i) in keywords"
          :key="i"
        >
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ItemSubject',
  props: { data: Object },
  computed: {
    title() {
      return this.data.title;
    },
    cover() {
      return this.data.property?.coverImage?.[0] || this.data?.imageList?.[0];
    },
    contentText() {
      return this.data.contentText;
    },
    keywords() {
      return (this.data.property.keyword || '').split(',');
    },
    topic() {
      return this.data.property?.topic?.[0] || {};
    },
    url() {
      return `//news.yorkbbs.ca/detail/${this.topic.englishName}/${this.data.id}`;
    },
  },
};
</script>
<style lang="less" scoped>
.subject-cover {
  width: 200px;
  height: 150px;
}
</style>
